module.exports = __webpack_public_path__ + "media/images/bg-count-275eddf50552d79f99934a6077171c3c.png";